import { AppThunk } from 'store/types';
import {
  setUploadVendorDocumentErrorAction,
  setUploadVendorDocumentFetchStatusAction,
  setVendorDocumentsDataAction,
  setVendorDocumentsErrorAction,
  setVendorDocumentsFetchStatusAction,
  setDeleteVendorDocumentErrorAction,
  setDeleteVendorDocumentFetchStatusAction,
} from './reducer';
import {
  createFetchedSuccess,
  createFetchedWithError,
  createFetchInProgress,
  createDefaultFetch,
} from 'types/rest/IFetchStatus';
import { getVendorOrderData } from '../vendorOrderData/dispatch';
import { IStandardDocumentData, IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { IUploadDocument } from 'types/order/documents/upload/interfaces';
import { deleteDocumentAsync, getDocumentsAsync, uploadDocumentAsync } from '../../../API/vendorDashboard/VendorAPI';

export const getVendorDocuments =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setVendorDocumentsErrorAction(undefined));
      dispatch(setVendorDocumentsFetchStatusAction(createFetchInProgress()));
      const response: IStandardDocumentVersionData[] = await getDocumentsAsync(orderId);
      dispatch(setVendorDocumentsDataAction({ orderId, value: response }));
      dispatch(setVendorDocumentsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setVendorDocumentsDataAction({ orderId, value: [] }));
      dispatch(setVendorDocumentsFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorDocumentsErrorAction(e.message));
    }
  };

export const uploadVendorDocuments =
  (orderId: string, documents: IUploadDocument[]): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setUploadVendorDocumentErrorAction(undefined));
      dispatch(setUploadVendorDocumentFetchStatusAction(createFetchInProgress()));
      const upload = Promise.all(
        documents.map(async (document: IUploadDocument) => await uploadDocumentAsync(orderId, document))
      );
      await upload;
      dispatch(setUploadVendorDocumentFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setUploadVendorDocumentFetchStatusAction(createFetchedWithError()));
      dispatch(setUploadVendorDocumentErrorAction(e.message));
    }
  };

export const resetUploadDocumentStatus =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    dispatch(setUploadVendorDocumentFetchStatusAction(createDefaultFetch()));
    dispatch(setUploadVendorDocumentErrorAction(undefined));
    const updateData = Promise.all([dispatch(getVendorDocuments(orderId)), dispatch(getVendorOrderData(orderId))]);
    // update list of document. A list can be updated or new items can be added depends on uploaded documents
    // update order status
    await updateData;
  };

export const deleteVendorDocument =
  (orderId: string, document: IStandardDocumentData): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setDeleteVendorDocumentErrorAction(undefined));
      dispatch(setDeleteVendorDocumentFetchStatusAction(createFetchInProgress()));
      await deleteDocumentAsync(orderId, document.id);
      dispatch(setDeleteVendorDocumentFetchStatusAction(createFetchedSuccess()));
      const documents = getState().vendorDashboard.documents.documents[orderId].filter((doc) => doc.id !== document.id);
      dispatch(setVendorDocumentsDataAction({ orderId, value: documents }));
    } catch (e: any) {
      dispatch(setDeleteVendorDocumentFetchStatusAction(createFetchedWithError()));
      dispatch(setDeleteVendorDocumentErrorAction(e.message));
    }
  };
